
import { useApp } from "@/lib/context";
import { translations } from "@/lib/translations";
import { Ban } from 'lucide-react';

interface BannedScreenProps {
  banReason?: string;
}

export default function BannedScreen({ banReason }: BannedScreenProps) {
  const { user } = useApp();
  const language = user?.language || 'it';
  const t = translations[language] || translations.it;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-900/20 via-black to-black p-6">
      <div className="max-w-md w-full space-y-8 text-center">
        {/* Icon */}
        <div className="flex justify-center">
          <div className="rounded-full bg-red-500/10 p-6 border-2 border-red-500/30">
            <Ban className="w-16 h-16 text-red-500" />
          </div>
        </div>

        {/* Title */}
        <div>
          <h1 className="text-3xl font-bold text-white mb-3">
            {t.banned.title}
          </h1>
          <p className="text-lg text-white/70">
            {t.banned.message}
          </p>
        </div>

        {/* Reason */}
        <div className="bg-red-500/5 border border-red-500/20 rounded-lg p-6">
          <p className="text-sm font-semibold text-red-400 mb-2">
            {t.banned.reason}
          </p>
          <p className="text-white/90">
            {banReason || t.banned.defaultReason}
          </p>
        </div>

        {/* Final Warning Message */}
        <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-4">
          <p className="text-white/90 font-medium">
            {t.banned.permanentMessage}
          </p>
        </div>

        {/* Info */}
        <div className="text-sm text-white/50">
          <p>
            {t.banned.supportInfo}
          </p>
        </div>
      </div>
    </div>
  );
}
